module.exports = __webpack_public_path__ + "static/media/Intruded tooth 7.452484d7.png";